const Browser = (function Browser() {
  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return (
      ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android')
    );
  }
  return {
    isIE:
      !!window.navigator.userAgent.match(/Trident/g) ||
      !!window.navigator.userAgent.match(/MSIE/g),
    isEdge: !!window.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
      window.navigator.userAgent
    ),
    isIos: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
  };
})();

export default Browser;
